import DebugTool from './component/debug-tool.vue';
var Debug = /** @class */ (function () {
    function Debug() {
    }
    Debug.install = function (Vue, options) {
        // Vue.component('query-browser', QueryBrowser);
        Vue.component('tc-debug-tool', DebugTool);
    };
    return Debug;
}());
export default Debug;
